import {BseDto, SeDto} from "../../autogen/bff-api";

export const eventIsDraft = (event: BseDto | SeDto): boolean => {
    return event.status === 'Draft'
}